import React, { Component } from 'react';
import "./Btnz.css";

const Btnz = (props) => {
    return ( <>
    
    <button className='Thebtnz'>{props.btn}</button>
    
    </> );
}
 
export default Btnz;